export default "__VITE_ASSET__CCyormfN__"